import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getAutomatedEmailTemplates: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/automatedEmailTemplates`,
        isArray: true
    },
    toggleTemplateStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/communication/automatedEmailTemplates/:notificationType`
    },
    getAutomatedEmailTemplatePreview: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/automatedEmailTemplates/:notificationType/preview`
    },
    revertAutomatedEmailTemplate: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/communication/automatedEmailTemplates/:notificationType/revert`
    },
    getAutomatedEmailTemplate: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/automatedEmailTemplates/:notificationType`
    },
    patchAutomatedEmailTemplate: {
        method: 'PATCH',
        url: `${BASE_PATH_API}/communication/automatedEmailTemplates/:notificationType`
    },
    saveAutomatedEmailTemplate: {
        method: 'POST',
        url: `${BASE_PATH_API}/communication/automatedEmailTemplates/:notificationType`
    },
    getEmailDeliverySettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/communication/automatedEmailTemplates/deliverySettings`
    },
    saveEmailDeliverySettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/communication/automatedEmailTemplates/deliverySettings`
    }
};

export function AutomatedEmailTemplatesApi() {
    return createActions(actions);
}
